// Copyright IBM Corp. 2015,2018. All Rights Reserved.
// Node module: strong-globalize
// This file is licensed under the Artistic License 2.0.
// License text available at https://opensource.org/licenses/Artistic-2.0
'use strict';

var _construct = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var StrongGlobalize = require('./lib/browser');

var util = require('util');
/**
 * A facade constructor for `StrongGlobalize`. It allows both
 * `const g = new SG(...)` and `const g = SG(...)` for backward compatibility.
 *
 * @param {*} args Constructor arguments for `StrongGlobalize`
 */


function SG() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (!(this instanceof SG)) {
    return _construct(SG, args);
  }

  return _construct(StrongGlobalize, args);
}

Object.setPrototypeOf(SG, StrongGlobalize);
util.inherits(SG, StrongGlobalize); // Expose the original `StrongGlobalize` class

SG.StrongGlobalize = StrongGlobalize;
module.exports = SG;